import { useCallback } from 'react';

import { useApi } from '../../../hooks/useApi';
import { useClubSlug } from '../../Clubs/hooks';
import { Category, ClubMember } from '../types';

interface Props {
    member: ClubMember;
    updateValue?: (category: Category, updatedServiceHours: number) => void;
    disabled?: boolean;
}

export const ServiceHoursComponent = ({ member, updateValue, disabled }: Props) => {
    const api = useApi();
    const slug = useClubSlug();
    const isReadOnly = disabled === true;

    const updateServiceHours = (category, value: number) => {
        if (isReadOnly) return;

        updateValue?.(category, category.member_service_hours + value);
        api({
            url: `club-member/${slug}/service-hours`,
            method: 'PUT',
            muted: true,
            data: {
                service_hours: value,
                members: [member.id],
                category_id: category.id
            },
            onFailure: () => updateValue?.(category, category.member_service_hours)
        });
    };

    const renderProgressWidth = useCallback((category: any) => {
        if (category.member_service_hours <= 0) return 0;
        if (category.member_service_hours >= category.service_hours) return 100;
        return (category.member_service_hours / category.service_hours || 1) * 100;
    }, []);

    return member.categories?.length > 0 ? (
        <div className="tw-overflow-hidden tw-rounded-md">
            {member.categories
                ?.filter((c) => c.service_hours > 0 || c.member_service_hours > 0)
                .map((category) => (
                    <div
                        className="tw-relative tw-flex tw-h-[20px] tw-w-auto tw-items-center tw-justify-center tw-overflow-hidden tw-bg-neutral-50 tw-text-black [&_>button]:tw-z-[1]"
                        key={`${member.id}_${category.id}`}
                    >
                        <div
                            className="tw-duration-250 tw-absolute tw-inset-0 tw-bg-green-500 tw-opacity-70 tw-transition-[width]"
                            style={{ width: renderProgressWidth(category) + '%' }}
                        />
                        {!isReadOnly && (
                            <div
                                className="tw-z-[1] tw-pb-[2px] tw-pl-[30px] tw-pr-[30px]"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    updateServiceHours(category, -1);
                                }}
                                onDoubleClick={(e) => e.stopPropagation()}
                            >
                                -
                            </div>
                        )}
                        <div className="tw-z-[1] tw-w-full tw-flex-[1_1_auto] tw-pb-[3px] tw-text-center tw-text-[10px]">
                            <span>
                                {category.member_service_hours || 0}
                                {category.member_service_hours ? ' / ' + (category.service_hours || 0) : ''}
                            </span>
                            <span className="tw-ml-4 tw-text-accents-8">({category.title})</span>
                        </div>
                        {!isReadOnly && (
                            <div
                                className="tw-z-[1] tw-pb-[2px] tw-pl-[30px] tw-pr-[30px]"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    updateServiceHours(category, 1);
                                }}
                                onDoubleClick={(e) => e.stopPropagation()}
                            >
                                +
                            </div>
                        )}
                    </div>
                ))}
        </div>
    ) : null;
};
